import _extends from "@babel/runtime/helpers/extends";
import { withDataConverter } from '@beef/react';
import { Preloader, useIsMobileDimension } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import { Button, CodeInput } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import React from 'react';
import { BackButton } from "../../../../HeaderButtons/BackButton/BackButton";
import { LogoButton } from "../../../../HeaderButtons/LogoButton/LogoButton";
import { ModalLayout } from "../../../../../../components/ModalLayout";
import { Title } from "../../../../../../components/Title";
import { findFirst } from "../../../../../../utils/arrays";
import withEnterKeyHandler from "../../../../../../utils/withOnEnterKeyHandler";
import { FormLayout } from "../SberPayModal/components/FormLayout";
import { converter } from "./components/Countdown/converter";
import styles from "./styles.pcss";
import { withCountdown } from "./withCountdown";
var cn = classNames.bind(styles);
export var EnhancedButton = compose(withCountdown(), withDataConverter(converter))(function (_ref) {
  var children = _ref.children,
    hasElapsed = _ref.hasElapsed,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Button, {
    className: cn('button'),
    disabled: !hasElapsed,
    mode: "inline",
    onClick: onClick,
    view: findFirst([hasElapsed && 'primary', 'tertiary']),
    width: "default",
    "data-t-id": "Popups-SMSConfirmationPopup"
  }, children);
});
export var EnhancedCodeInput = withEnterKeyHandler(CodeInput);
export var SMSConfirmationPopup = function SMSConfirmationPopup(_ref2) {
  var backButtonProps = _ref2.backButtonProps,
    titleProps = _ref2.titleProps,
    buttonProps = _ref2.buttonProps,
    codeInputProps = _ref2.codeInputProps,
    isLoading = _ref2.isLoading;
  var isMobile = useIsMobileDimension();
  return /*#__PURE__*/React.createElement(ModalLayout, {
    contentProps: {
      className: cn('wrapper')
    },
    wrapperProps: {
      className: cn('outer')
    }
  }, /*#__PURE__*/React.createElement(ModalLayout.Header, null, /*#__PURE__*/React.createElement(BackButton, _extends({}, backButtonProps, {
    isWhite: true
  })), /*#__PURE__*/React.createElement(LogoButton, null)), /*#__PURE__*/React.createElement(ModalLayout.Content, null, /*#__PURE__*/React.createElement(Title, {
    isCentered: !isMobile,
    subtitle: titleProps.subTitle,
    title: titleProps.title
  }), /*#__PURE__*/React.createElement(FormLayout, {
    wrapperProps: {
      className: cn('content')
    }
  }, /*#__PURE__*/React.createElement(FormLayout.Input, null, findFirst([isLoading && /*#__PURE__*/React.createElement(Preloader, {
    color: "dark",
    size: "m"
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EnhancedCodeInput, _extends({}, codeInputProps, {
    withMobileOffset: false
  })), /*#__PURE__*/React.createElement(EnhancedButton, buttonProps))])))));
};